import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { Tematica } from '../types/Tematica/Tematica';
import { ResponseApi } from '../types/Response/ResponseApi';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APITEMATICAS = 'api/Catalog/Tematica/';

export default class TematicaService {

    static async GetTematicas(page: number = 1, pageSize: number = 25): Promise<ResponseApi<Tematica>> {
        const response: AxiosResponse<ResponseApi<Tematica>> = await apiInterceptor.get(
            `${SERV_BACK}${APITEMATICAS}?page=${page}&pageSize=${pageSize}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async GetTematicasByName(key: string, page: number = 1, pageSize: number = 25): Promise<ResponseApi<Tematica>> {
        const response: AxiosResponse<ResponseApi<Tematica>> = await apiInterceptor.get(
            `${SERV_BACK}${APITEMATICAS}byName/${key}?page=${page}&pageSize=${pageSize}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async GetTematicasActivas(): Promise<ResponseApi<Tematica>> {
        const response: AxiosResponse<ResponseApi<Tematica>> = await apiInterceptor.get(
            `${SERV_BACK}${APITEMATICAS}Actives`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async ActivarTematica(id: number): Promise<ResponseApi<Tematica>> {
        const response: AxiosResponse<ResponseApi<Tematica>> = await apiInterceptor.put(
            `${SERV_BACK}${APITEMATICAS}Activate/${id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async InactivarTematica(id: number): Promise<ResponseApi<Tematica>> {
        const response: AxiosResponse<ResponseApi<Tematica>> = await apiInterceptor.put(
            `${SERV_BACK}${APITEMATICAS}Inactivate/${id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async EditarTematica(obj: Tematica): Promise<ResponseApi<Tematica>> {
        const response: AxiosResponse<ResponseApi<Tematica>> = await apiInterceptor.put(
            `${SERV_BACK}${APITEMATICAS}${obj.idTematica}`,
            obj,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async CrearTematica(obj: Tematica): Promise<ResponseApi<Tematica>> {
        const response: AxiosResponse<ResponseApi<Tematica>> = await apiInterceptor.post(
            `${SERV_BACK}${APITEMATICAS}`,
            obj,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

}